import { ReactNode, useState } from 'react';

import { Column, Tabs, Tag } from 'components/Blocks';

import { UserActionList } from './ActionList';
import { SecondaryTeams } from './SecondaryTeams';

import { useUser } from 'hooks';

interface Props {
  children: ReactNode;
}

export function UserActionTabWrap({ children }: Props) {
  const user = useUser();

  const [tab, setTab] = useState('data');

  if (!user.isSysAdmin) return <>{children}</>;

  return (
    <Column>
      <Tabs
        value={tab}
        onTabChange={setTab}
        type="highlighted"
        tabs={[
          {
            value: 'data',
            getLabel: (t) => t('info'),
            content: <>{children}</>,
          },
          {
            value: 'actions',
            getLabel: (t) => t('actions'),
            icon: <Tag name="BETA" size="tiny" color="warning-light" />,
            content: <UserActionList />,
          },
          {
            value: 'secondary-teams',
            getLabel: (t) => t('secondary-teams'),
            content: <SecondaryTeams />,
          },
        ]}
      />
    </Column>
  );
}
